module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 linkTableMediumSmall",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.objManuPlists,
      "hide-actions": "",
      "rows-per-page-items": [1000]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          attrs: {
            "label": "",
            "checked": "checked"
          },
          model: {
            value: (props.item.pl_active),
            callback: function($$v) {
              _vm.$set(props.item, "pl_active", $$v)
            },
            expression: "props.item.pl_active"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "45%"
          }
        }, [_vm._v(_vm._s(props.item.pl_name))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "45%"
          }
        }, [_vm._v(_vm._s(props.item.pl_description))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdatePlists.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_vm._v("\n\t\t\t\t \n\t\t\t")])], 1)], 1)
},staticRenderFns: []}